if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      this.productElement = null;
    }

    hide(preventFocus = false) {
      const cartNotification =
        document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      if (this.modalContent) this.modalContent.innerHTML = '';
      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');

      const spinner = opener.querySelector('.loading-overlay-spinner');
      if (spinner) spinner.classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          if (!this.productElement || !this.modalContent) return;

          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          // Shopify init
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();

          super.show(opener);

          this.modalContent.style.opacity = '0';
          this.modalContent.style.transform = 'scale(0.8)';
          this.modalContent.style.transition = 'opacity 0.3s ease, transform 0.3s ease';

          setTimeout(() => {
            this.modalContent.style.opacity = '1';
            this.modalContent.style.transform = 'scale(1)';
            if (window.AOS && typeof window.AOS.init === 'function') window.AOS.init();
          }, 0);

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.autoplayActiveMediaInModal();
            });
          });
        })
        .catch((e) => {
          // optional: log
          // console.error('Quick add fetch failed', e);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      if (!this.productElement) return;

      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog && modalDialog.length) modalDialog.forEach(modal => modal.remove());
    }

    preventDuplicatedIDs() {
      if (!this.productElement) return;

      const sectionId = this.productElement.dataset.section;
      if (!sectionId) return;

      this.productElement.innerHTML =
        this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);

      this.productElement
        .querySelectorAll('variant-selects, variant-radios, product-info')
        .forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
    }

    removeGalleryListSemantic() {
      if (!this.modalContent) return;

      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      if (!this.modalContent) return;

      const product = this.modalContent.querySelector('.product');
      if (!product) return;

      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes =
        '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }

    autoplayActiveMediaInModal() {
      if (!this.modalContent) return;

      const activeSlide =
        this.modalContent.querySelector('.product-media-item.is-active') ||
        this.modalContent.querySelector('[data-media-id].is-active') ||
        this.modalContent.querySelector('[data-media-id]');

      if (!activeSlide) return;

      const deferredMedia = activeSlide.querySelector('deferred-media[data-autoplay="true"]');
      if (!deferredMedia) return;

      if (typeof deferredMedia.loadContent === 'function') {
        deferredMedia.loadContent(false);
      }

      if (typeof deferredMedia.autoplayVideo === 'function') {
        deferredMedia.autoplayVideo();
        return;
      }

      const video = deferredMedia.media || deferredMedia.querySelector('video');
      if (video && video.tagName === 'VIDEO') {
        video.muted = true;
        video.playsInline = true;
        const p = video.play();
        if (p && p.catch) p.catch(() => {});
      }
    }
  });
}
